import { render, staticRenderFns } from "./follow-modify.vue?vue&type=template&id=0c95d5e8&scoped=true"
import script from "./follow-modify.vue?vue&type=script&lang=ts"
export * from "./follow-modify.vue?vue&type=script&lang=ts"
import style0 from "./follow-modify.vue?vue&type=style&index=0&id=0c95d5e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c95d5e8",
  null
  
)

export default component.exports